import { NpiDestinationEnum, SwoopIntegrationTypeEnum } from '../../dto/recs.dto';
import { AdSet } from '../../entities/ad-set';
import { IntegrationInterface } from '../../interfaces/components/integrations/IntegrationInterface';
import { BrowserObjectModel } from '../browser-object-model';
import { UserContext } from '../context/user.context';
import { Injectable } from '../dependency-injection/decorators';
import { IntegrationRunException } from '../exception/integration-run.exception';

@Injectable()
export class SwoopDefaultIntegration implements IntegrationInterface {
  public constructor (
    protected readonly browserObjectModel: BrowserObjectModel,
    protected readonly userContext: UserContext,
  ) {
  }

  public async run (adSet: AdSet): Promise<void> {
    if (!this.supports(adSet)) {
      return;
    }

    const encryptedNpiNumber = this.userContext
      .getNpis()
      .find((innerNpi) => innerNpi.getDestination() === NpiDestinationEnum.SWOOP)
      ?.getEncryptedNumber();

    if (!encryptedNpiNumber) {
      return;
    }

    const scriptUrl = adSet.getSettings().getSwoopScriptUrl();
    const id = adSet.getSettings().getSwoopId();

    if (!scriptUrl || !id) {
      throw new IntegrationRunException(this, adSet);
    }

    const script = this.browserObjectModel.getDocument().createElement('script');
    script.src = scriptUrl;
    script.id = 'swoop_sdk';
    script.dataset[ 'domain' ] = id;
    script.dataset[ 'npi' ] = encryptedNpiNumber;
    this.browserObjectModel.getDocument().getElementsByTagName('body')[ 0 ].appendChild(script);
  }

  public supports (adSet: AdSet): boolean {
    return adSet.getSettings().getSwoopIntegrationType() === SwoopIntegrationTypeEnum.DEFAULT;
  }
}
